import { render } from "./Roadmap.vue?vue&type=template&id=48f99b1a&scoped=true"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"

import "./Roadmap.vue?vue&type=style&index=0&id=48f99b1a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-48f99b1a"

export default script